export default "__VITE_ASSET__CKHc$Urv__"